export type RoomStatus = 'connected' | 'reconnecting' | 'disconnected'
export type SyncClientStatus = 'connected' | 'disconnected' | 'connecting'
export interface SessionEventLog {
  event: string
  dstamp: string
}

export interface SessionStatusReducer {
  roomStatus: RoomStatus
  syncClientStatus: SyncClientStatus
  eventLog: SessionEventLog[]
}

const defaultState: SessionStatusReducer = {
  roomStatus: 'disconnected',
  syncClientStatus: 'disconnected',
  eventLog: []
}

export default defaultState
